module.exports = __webpack_public_path__ + "img/strenth+5.c7b0d560.webp";